/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R403RouteImport } from './routes/403'
import { Route as R404RouteImport } from './routes/404'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ArchivedRouteImport } from './routes/archived'
import { Route as AttachmentsRouteImport } from './routes/attachments'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ChatImportRouteImport } from './routes/chat-import'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as HomeRouteImport } from './routes/home'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as SettingRouteImport } from './routes/setting'
import { Route as ShortcutsRouteImport } from './routes/shortcuts'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthAdminRouteImport } from './routes/auth/admin'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as MemosUidRouteImport } from './routes/memos/$uid'
import { Route as UUsernameRouteImport } from './routes/u/$username'
import { Route as MemosSharesTokenRouteImport } from './routes/memos/shares/$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchivedRoute = ArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => rootRouteImport,
} as any)
const AttachmentsRoute = AttachmentsRouteImport.update({
  id: '/attachments',
  path: '/attachments',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatImportRoute = ChatImportRouteImport.update({
  id: '/chat-import',
  path: '/chat-import',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingRoute = SettingRouteImport.update({
  id: '/setting',
  path: '/setting',
  getParentRoute: () => rootRouteImport,
} as any)
const ShortcutsRoute = ShortcutsRouteImport.update({
  id: '/shortcuts',
  path: '/shortcuts',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const MemosUidRoute = MemosUidRouteImport.update({
  id: '/memos/$uid',
  path: '/memos/$uid',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameRoute = UUsernameRouteImport.update({
  id: '/u/$username',
  path: '/u/$username',
  getParentRoute: () => rootRouteImport,
} as any)
const MemosSharesTokenRoute = MemosSharesTokenRouteImport.update({
  id: '/memos/shares/$token',
  path: '/memos/shares/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/archived': typeof ArchivedRoute
  '/attachments': typeof AttachmentsRoute
  '/auth': typeof AuthRouteWithChildren
  '/chat-import': typeof ChatImportRoute
  '/explore': typeof ExploreRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/setting': typeof SettingRoute
  '/shortcuts': typeof ShortcutsRoute
  '/auth/admin': typeof AuthAdminRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signup': typeof AuthSignupRoute
  '/memos/$uid': typeof MemosUidRoute
  '/u/$username': typeof UUsernameRoute
  '/auth/': typeof AuthIndexRoute
  '/memos/shares/$token': typeof MemosSharesTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/archived': typeof ArchivedRoute
  '/attachments': typeof AttachmentsRoute
  '/chat-import': typeof ChatImportRoute
  '/explore': typeof ExploreRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/setting': typeof SettingRoute
  '/shortcuts': typeof ShortcutsRoute
  '/auth/admin': typeof AuthAdminRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signup': typeof AuthSignupRoute
  '/memos/$uid': typeof MemosUidRoute
  '/u/$username': typeof UUsernameRoute
  '/auth': typeof AuthIndexRoute
  '/memos/shares/$token': typeof MemosSharesTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/archived': typeof ArchivedRoute
  '/attachments': typeof AttachmentsRoute
  '/auth': typeof AuthRouteWithChildren
  '/chat-import': typeof ChatImportRoute
  '/explore': typeof ExploreRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/setting': typeof SettingRoute
  '/shortcuts': typeof ShortcutsRoute
  '/auth/admin': typeof AuthAdminRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signup': typeof AuthSignupRoute
  '/memos/$uid': typeof MemosUidRoute
  '/u/$username': typeof UUsernameRoute
  '/auth/': typeof AuthIndexRoute
  '/memos/shares/$token': typeof MemosSharesTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/404'
    | '/about'
    | '/archived'
    | '/attachments'
    | '/auth'
    | '/chat-import'
    | '/explore'
    | '/home'
    | '/inbox'
    | '/setting'
    | '/shortcuts'
    | '/auth/admin'
    | '/auth/callback'
    | '/auth/signup'
    | '/memos/$uid'
    | '/u/$username'
    | '/auth/'
    | '/memos/shares/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/404'
    | '/about'
    | '/archived'
    | '/attachments'
    | '/chat-import'
    | '/explore'
    | '/home'
    | '/inbox'
    | '/setting'
    | '/shortcuts'
    | '/auth/admin'
    | '/auth/callback'
    | '/auth/signup'
    | '/memos/$uid'
    | '/u/$username'
    | '/auth'
    | '/memos/shares/$token'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/404'
    | '/about'
    | '/archived'
    | '/attachments'
    | '/auth'
    | '/chat-import'
    | '/explore'
    | '/home'
    | '/inbox'
    | '/setting'
    | '/shortcuts'
    | '/auth/admin'
    | '/auth/callback'
    | '/auth/signup'
    | '/memos/$uid'
    | '/u/$username'
    | '/auth/'
    | '/memos/shares/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  ArchivedRoute: typeof ArchivedRoute
  AttachmentsRoute: typeof AttachmentsRoute
  AuthRoute: typeof AuthRouteWithChildren
  ChatImportRoute: typeof ChatImportRoute
  ExploreRoute: typeof ExploreRoute
  HomeRoute: typeof HomeRoute
  InboxRoute: typeof InboxRoute
  SettingRoute: typeof SettingRoute
  ShortcutsRoute: typeof ShortcutsRoute
  MemosUidRoute: typeof MemosUidRoute
  UUsernameRoute: typeof UUsernameRoute
  MemosSharesTokenRoute: typeof MemosSharesTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archived': {
      id: '/archived'
      path: '/archived'
      fullPath: '/archived'
      preLoaderRoute: typeof ArchivedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attachments': {
      id: '/attachments'
      path: '/attachments'
      fullPath: '/attachments'
      preLoaderRoute: typeof AttachmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-import': {
      id: '/chat-import'
      path: '/chat-import'
      fullPath: '/chat-import'
      preLoaderRoute: typeof ChatImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setting': {
      id: '/setting'
      path: '/setting'
      fullPath: '/setting'
      preLoaderRoute: typeof SettingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shortcuts': {
      id: '/shortcuts'
      path: '/shortcuts'
      fullPath: '/shortcuts'
      preLoaderRoute: typeof ShortcutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/admin': {
      id: '/auth/admin'
      path: '/admin'
      fullPath: '/auth/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/memos/$uid': {
      id: '/memos/$uid'
      path: '/memos/$uid'
      fullPath: '/memos/$uid'
      preLoaderRoute: typeof MemosUidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username': {
      id: '/u/$username'
      path: '/u/$username'
      fullPath: '/u/$username'
      preLoaderRoute: typeof UUsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memos/shares/$token': {
      id: '/memos/shares/$token'
      path: '/memos/shares/$token'
      fullPath: '/memos/shares/$token'
      preLoaderRoute: typeof MemosSharesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  ArchivedRoute: ArchivedRoute,
  AttachmentsRoute: AttachmentsRoute,
  AuthRoute: AuthRouteWithChildren,
  ChatImportRoute: ChatImportRoute,
  ExploreRoute: ExploreRoute,
  HomeRoute: HomeRoute,
  InboxRoute: InboxRoute,
  SettingRoute: SettingRoute,
  ShortcutsRoute: ShortcutsRoute,
  MemosUidRoute: MemosUidRoute,
  UUsernameRoute: UUsernameRoute,
  MemosSharesTokenRoute: MemosSharesTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
